import { AppEnvironment } from '../../models/environment/app-environment.type';
import { mockAppBuildConfig } from '../build/app-build-config.mock';

export const mockAppEnvironment: AppEnvironment = {
  ...mockAppBuildConfig,
  runtimeConfigPath: '',
  production: false,
};
